import { render, staticRenderFns } from "./Sliders.vue?vue&type=template&id=120c2f15&"
import script from "./Sliders.vue?vue&type=script&lang=js&"
export * from "./Sliders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports